import { connect } from 'react-redux';
import { getIsHotelOnly, getIsMobile } from 'src/store/view/selectors';
import {
  selectPreviousPrice,
  getActualizationFetching,
  getLastUpdated,
  getShowPriceChanged,
} from '../../store/selectors/actualization';
import { getPackageFullPrice } from '../../store/selectors/order';
import { selectNewPrice } from '../../store/selectors/price';
import PriceChecker from './PriceChecker';

const mapStateToProps = (state) => ({
  priceChanged: getShowPriceChanged(state),
  oldPrice: selectPreviousPrice(state),
  currentPrice: getIsHotelOnly(state)
    ? getPackageFullPrice(state)
    : selectNewPrice(state),
  lastUpdated: getLastUpdated(state) || 0,
  fetching: getActualizationFetching(state),
  isMobile: getIsMobile(state),
});

export default connect(mapStateToProps)(PriceChecker);
